import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import Cookies from "js-cookie";

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  show: false,
  subjectList: [],
  //  图片地址
  upload_url: "http://tangapi.demwlxx.com/banner/uploadImg1",
  img_url: "http://tangapi.demwlxx.com",
  // 地址
  export_url: "http://managersh.demshfw.com:81/"

}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js